import { FC } from 'react';
import Skeleton from '@mui/material/Skeleton';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';

type Props = {
  columns: Array<{ key: string }>;
  rowsPerPage?: number;
};

const TableSkeleton: FC<Props> = ({ columns, rowsPerPage = 5 }) => {
  return (
    <>
      {Array.from({ length: rowsPerPage }).map((_, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <TableRow key={`skeleton-${index}`}>
          {columns.map((column) => (
            <TableCell size="medium" key={`skeleton-${column.key}`}>
              <Skeleton variant="text" />
            </TableCell>
          ))}
        </TableRow>
      ))}
    </>
  );
};

export default TableSkeleton;
